var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 181,
    viewBox: "0 0 145 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.5 0C107.101 -5.24609e-08 102.745 0.866503 98.6801 2.55004C94.6157 4.23357 90.9227 6.70116 87.8119 9.81192C84.7012 12.9227 82.2336 16.6157 80.55 20.6801C78.8665 24.7445 78 29.1007 78 33.5C78 37.8993 78.8665 42.2555 80.55 46.3199C82.2336 50.3843 84.7012 54.0773 87.8119 57.1881C90.9227 60.2988 94.6157 62.7664 98.6801 64.45C102.745 66.1335 107.101 67 111.5 67V59.4761C108.089 59.4761 104.711 58.8042 101.559 57.4988C98.4078 56.1934 95.5442 54.28 93.1321 51.8679C90.72 49.4558 88.8066 46.5922 87.5012 43.4406C86.1958 40.2891 85.5239 36.9112 85.5239 33.5C85.5239 30.0888 86.1958 26.7109 87.5012 23.5594C88.8066 20.4078 90.72 17.5442 93.1321 15.1321C95.5442 12.72 98.4078 10.8066 101.559 9.50122C104.711 8.1958 108.089 7.52391 111.5 7.52391V0Z",
    fill: "#C1C1E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2 144L39 107L76 144L113 107",
    stroke: "#C1C1E9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2 170.5L39 133.5L76 170.5L113 133.5",
    stroke: "#C1C1E9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidDesign);
export default __webpack_public_path__ + "static/media/mid-design.d3545dd98a3c5e0b98ae347b23cf3b75.svg";
export { ForwardRef as ReactComponent };